import { createTrackingUtils } from "../index";

const utils = createTrackingUtils({
  name: "flights_apex_web_skip_empty_ancillary_page",
  stages: {
    decide_steps: 1,
    decide_steps_no_ancillary: 2,
    decide_steps_no_ancillary_bf: 3,
    decide_steps_no_ancillary_no_bf: 3,
    next_to_ancillary: 5, // main,
    next_to_ancillary_bf: 6,
    next_to_ancillary_no_bf: 7
  },
  goals: {
    meal_offered: 1,
    empty_extras_page: 2,
    any_ancillary_showed: 3
  },
  defaultStage: 1
});

export default { ...utils };
